import { OrderCallWrapper } from '@/components/features/OrderCallWrapper/OrderCallWrapper';
import { SvgFloatingButton } from '@/components/icons';
import s from './floatingCallButton.module.scss';

export const FloatingCallButton = () => {
  return (
    <div className={s.floatingCallButton}>
      <div className={s.container}>
        <OrderCallWrapper>
          <SvgFloatingButton />
        </OrderCallWrapper>
      </div>
    </div>
  );
};